// WorkOrderProfileService.tsx
import { useInfiniteQuery } from '@tanstack/react-query';
import { WorkOrderProfileService } from '../../core/services';
import { PageSize } from '../../type';

export const useGetWorkOrderService = (initialParams: PageSize) => {
  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching } =
    useInfiniteQuery({
      queryKey: ['get-workorders-data'],
      queryFn: async ({ pageParam }) => {
        return WorkOrderProfileService.getWorkOrder({
          page: initialParams.pageNumber ?? pageParam,
          size: initialParams.size,
          workOrderNo: initialParams.workOrderNo,
          stationId: initialParams.stationId,
          vehiclePlate: initialParams.vehiclePlate,
          vehicleVin: initialParams.vehicleVin,
          status: initialParams.status,
          start: initialParams.start,
          end: initialParams.end,
          vehicleId: initialParams.vehicleId,
        });
      },
      initialPageParam: 1,
      getNextPageParam: (res) => (!res?.last ? res?.number + 1 : undefined),
      enabled: false,
      retry: 1,
      retryDelay: 36000000,
    });
  const isDataFetching = isFetching || isFetchingNextPage;

  return {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isDataFetching,
  };
};
